import { Button, Loading } from '@carboncopyco/ui';
import {
  useDemoLinkProps,
  useDemoLinkSubmitAndCopy,
} from './DemoLinkModalContext';

export const DemoLinkSubmitAndCopy = ({
  allowed,
  disabled,
}: {
  allowed?: boolean;
  disabled?: boolean;
}) => {
  const { link, isLoading } = useDemoLinkProps();
  const [submit, copyLink] = useDemoLinkSubmitAndCopy();

  if (!allowed || disabled) {
    return null;
  }

  return link ? (
    <Button
      secondary
      label="Copy link"
      onClick={copyLink}
    />
  ) : (
    <Button
      label="Generate Link"
      onClick={submit}
      disabled={isLoading}
      leftIcon={isLoading && <Loading color="text-ds-primary" />}
    />
  );
};
